import React, { useState } from "react"
import { Row, Offcanvas, OffcanvasHeader, OffcanvasBody, Container, Col, Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"

import InvoiceOrders from "./index"
import OrderForm from "pages/Orders/OrderForm"
import OrdersFormComponent from "components/OrdersFormComponent"

const OrdersModel = props => {
  const { isOpen, toggle, value } = props
  return (
    <React.Fragment>
      <Row>
        <Offcanvas isOpen={isOpen} direction="end" toggle={toggle}  style={{width:"35%"}}>
          <OffcanvasHeader toggle={toggle}>{value.rec}</OffcanvasHeader>
          <OffcanvasBody>
            <Container>
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                    <OrdersFormComponent requestFor={value.rec} orderRec= {value.order} toggle={toggle}/>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </OffcanvasBody>
        </Offcanvas>
      </Row>
    </React.Fragment>
  )
}
OrdersModel.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  value: PropTypes.object
  // orderObject: PropTypes.object
}

export default OrdersModel
